import React from 'react';
import { Mail, ShieldCheck } from 'lucide-react';

const WorkerInfoCards = ({ email, kycVerified }) => {
  return (
    <div className="wp-info-cards">
      {/* <div className="wp-info-card">
        <Phone size={17} className="wp-info-card__icon wp-info-card__icon--blue" />
        <span>{phoneNumber}</span>
      </div> */}
      <div className="wp-info-card">
        <Mail size={17} className="wp-info-card__icon wp-info-card__icon--green" />
        <span>{email}</span>
      </div>
      <div className="wp-info-card">
        <ShieldCheck size={17} className="wp-info-card__icon wp-info-card__icon--teal" />
        <span>
          {
            kycVerified
              ? "KYC Verified ✓"
              : "KYC Not Verified"
          }
        </span>
      </div>
    </div>
  );
};

export default WorkerInfoCards;